import {AssetsRequestParams} from "../../../infrastructure/models/params/assets-request-params";

export class RecentMatchBadgeImageRequestParams extends AssetsRequestParams {
  constructor(id: Number, width: Number, height: Number) {
    super(width, height);

    this.resourceName = `${this.resourceName}/FormBadges/${id}`
    this.c = null;
  }
}